/*
 * @Author: xcy
 * @Date: 2021-06-05 11:18:00
 * @LastEditTime: 2022-01-20 17:12:14
 * @LastEditors: xcy
 * @Description: 
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./plugins/vant";
import api from "./api/api";
import store from "./store";
import VueAwesomeSwiper from "vue-awesome-swiper";
import bus from "vue-bus"
import VShowSlide from 'v-show-slide'
Vue.use(VShowSlide)
Vue.use(bus)
// import style (>= Swiper 6.x)
import "../node_modules/swiper/swiper-bundle.css";
import lrz from "lrz";
Vue.prototype.$lrz = lrz;
import dayjs from "dayjs";
// // import style (<= Swiper 5.x)
import "../node_modules/swiper/swiper.min.css";
Vue.prototype.$dayjs = dayjs;
Vue.filter("formant", (value) => {
    //
    return value ? dayjs(value).format("YYYY-MM-DD HH:mm:ss") : "-";
});
import { ImagePreview } from 'vant';
Vue.use(ImagePreview);
Vue.prototype.switch_image = function (item,index) {
    const images = typeof item=='object'?item:[item];
    ImagePreview({images:images,startPosition:index||0});
}

import PageContent from "../src/components/templateContent";
localStorage.removeItem("videoId");
Vue.component("PageContent", PageContent);
// import "../node_modules/"
Vue.use(VueAwesomeSwiper);
Vue.config.productionTip = false;
Vue.prototype.$api = api;
Vue.prototype.bus = new Vue();
Vue.prototype.$CopyStr = function copyUrl(url) {
    // 创建一个 Input标签
    const cInput = document.createElement("input");
    cInput.value = url;
    document.body.appendChild(cInput);
    cInput.select(); // 选取文本域内容;
    // 执行浏览器复制命令
    // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
    // Input要在正常的编辑状态下原生复制方法才会生效
    document.execCommand("Copy");
    alert("复制成功");
    /// 复制成功后再将构造的标签 移除
    cInput.remove();
};
Vue.prototype.GetRequest = (parmasStr) => {
    var url = parmasStr ? parmasStr : location.search; //获取url中"?"符后的字串
    var theRequest = new Object();
    if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        const strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
        }
    }
    return theRequest;
};
Vue.prototype.$setApptitle = (title) => {
    window.addEventListener(
        "flutterInAppWebViewPlatformReady",
        function () { }
    );
    window.flutter_inappwebview.callHandler("setAppTitle", { title: title });
};
new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");